export const JOB_PROFILES = [
    "Marketing Specialist",
    "Marketing Manager",
    "Marketing Director",
    "Graphic Designer",
    "Marketing Research Analyst",
    "Marketing Communications Manager",
    "Marketing Consultant",
    "Product Manager",
    "Public Relations",
    "Social Media Assistant",
    "Brand Manager",
    "SEO Manager",
    "Content Marketing Manager",
    "Copywriter",
    "Media Buyer",
    "Digital Marketing Manager",
    "eCommerce Marketing Specialist",
    "Brand Strategist",
    "Vice President of Marketing",
    "Media Relations Coordinator",
    "Administrative Assistant",
    "Receptionist",
    "Office Manager",
    "Auditing Clerk",
    "Bookkeeper",
    "Account Executive",
    "Branch Manager",
    "Business Manager",
    "Quality Control Coordinator",
    "Administrative Manager",
    "Chief Executive Officer",
    "Business Analyst",
    "Risk Manager",
    "Human Resources",
    "Office Assistant",
    "Secretary",
    "Office Clerk",
    "File Clerk",
    "Account Collector",
    "Administrative Specialist",
    "Executive Assistant",
    "Program Administrator",
    "Program Manager",
    "Administrative Analyst",
    "Data Entry",
    "Chief Executive Officer (CEO)",
    "Chief Operating Officer (COO)",
    "Chief Financial Officer (CFO)",
    "Chief Information Officer (CIO)",
    "Chief Technology Officer (CTO)",
    "Chief Marketing Officer (CMO)",
    "Chief Human Resources Officer (CHRO)",
    "Chief Data Officer (CDO)",
    "Chief Product Officer (CPO)",
    "Chief Customer Officer (CCO)",
    "Computer Scientist",
    "IT Professional",
    "UX Designer & UI Developer",
    "SQL Developer",
    "Web Designer",
    "Web Developer",
    "Help Desk Worker/Desktop Support",
    "Software Engineer",
    "DevOps Engineer",
    "Computer Programmer",
    "Network Administrator",
    "Information Security Analyst",
    "Artificial Intelligence Engineer",
    "Cloud Architect",
    "IT Manager",
    "Technical Specialist",
    "Application Developer",
    "Sales Associate",
    "Sales Representative",
    "Sales Manager",
    "Retail Worker",
    "Store Manager",
    "Real Estate Broker",
    "Cashier",
    "Account Manager",
    "Area Sales Manager",
    "Direct Salesperson",
    "Director of Inside Sales",
    "Outside Sales Manager",
    "Sales Analyst",
    "Market Development Manager",
    "B2B Sales Specialist",
    "Sales Engineer",
    "Merchandising Associate",
    "Researcher",
    "Research Assistant",
    "Data Analyst",
    "Financial Analyst",
    "Biostatistician",
    "Title Researcher",
    "Market Researcher",
    "Title Analyst",
    "Medical Researcher",
    "Virtual Assistant",
    "Customer Service",
    "Customer Support",
    "Concierge",
    "Help Desk",
    "Customer Service Manager",
    "Technical Support Specialist",
    "Account Representative",
    "Client Service Specialist",
    "Customer Care Associate",
    "Computer systems manager",
    "Network architect",
    "Systems analyst",
    "IT coordinator",
    "Network engineer",
    "Service desk analyst",
    "System administrator",
    "Wireless network engineer",
    "Database administrator",
    "Database analyst",
    "Data quality manager",
    "Database report writer",
    "SQL database administrator",
    "Big data engineer/architect",
    "Business intelligence specialist/analyst",
    "Business systems analyst",
    "Data analytics developer",
    "Data modeling analyst",
    "Data scientist",
    "Data warehouse manager",
    "Data warehouse programming specialist",
    "Intelligence specialist",
    "Back-end developer",
    "Cloud/software developer",
    "Cloud/software applications engineer",
    "Cloud system administrator",
    "Cloud system engineer",
    "Front-end developer",
    "Full-stack developer",
    "Senior Java developer (Sr. Java Developer)",
    "Java developer",
    "Platform engineer",
    "Release manager",
    "Reliability engineer",
    "Software quality assurance analyst",
    "UI (user interface) designer",
    "UX (user experience) designer",
    "Application security administrator",
    "Artificial intelligence security specialist",
    "Cloud security specialist",
    "Cybersecurity hardware engineer",
    "Cyberintelligence specialist",
    "Cryptographer",
    "Data privacy officer",
    "Digital forensics analyst",
    "IT security engineer",
    "Information assurance analyst",
    "Security systems administrator",
    "Help desk support specialist",
    "IT support specialist",
    "Customer service representative",
    "Technical product manager",
    "Project manager",
    "Portfolio manager",
    "Cloud Consultant",
    "Cloud Product and Project Manager",
    "Cloud Services Developer",
    "Cloud Software and Network Engineer",
    "Computer and Information Research Scientist",
    "Computer and Information Systems Manager",
    "Computer Network Architect",
    "Computer Systems Analyst",
    "IT Analyst",
    "Network and Computer Systems Administrator",
    "Network Systems Administrator",
    "Senior Network Architect",
    "Senior Network Engineer",
    "Senior Network System Administrator",
    "Telecommunications Specialist",
    "Customer Support Administrator",
    "Customer Support Specialist",
    "Desktop Support Manager",
    "Desktop Support Specialist",
    "Help Desk Specialist",
    "Help Desk Technician",
    "IT Support Manager",
    "IT Systems Administrator",
    "Senior Support Specialist",
    "Senior System Administrator",
    "Support Specialist",
    "Systems Administrator",
    "Technical Support Engineer",
    "Data Center Support Specialist",
    "Senior Database Administrator",
    "Application Support Analyst",
    "Junior System Analyst",
    "System Analyst (Systems Analyst)",
    "Senior System Analyst (Sr. System Analyst",
    "Systems Designer",
    "Director of Technology",
    "IT Director",
    "Management Information Systems Director",
    "Technical Operations Officer",
    "Security Specialist",
    "Senior Security Specialist",
    "Applications Engineer",
    "Associate Developer",
    "Developer",
    "Junior Software Engineer",
    ".NET Developer",
    "Programmer",
    "Programmer Analyst",
    "Senior Applications Engineer",
    "Senior Programmer",
    "Senior Programmer Analyst",
    "Senior Software Engineer (Sr. Software Engineer)",
    "Senior System Architect (Sr. System Architect)",
    "Senior System Designer (Sr. System Designer",
    "System Software Engineer",
    "Software Systems Specialist",
    "Senior Systems Software Engineer (Sr. Systems Software Engineer)",
    "Software Architect",
    "Software Developer",
    "System Architect",
    "Systems Software Engineer",
    "Frontend Developer (Front-end Developer)",
    "Front End Developer",
    "Senior Front End Developer",
    "Junior Web Administrator",
    "Junior Web Developer",
    "Senior Web Administrator",
    "Senior Web Developer",
    "Web Administrator",
    "Information Technology Analyst",
    "Junior Applications Engineer",
    "Junior Programmer",
    "Junior Programmer Analyst",
    "Junior System Architect",
    "Junior System Designer",
    "Junior Systems Software Engineer",
    " chief executive officer",
    " chief financial officer",
    " chief marketing officer",
    " marketing director",
    " it director",
    " mis director",
    " application development director",
    " president",
    " vice president",
    " it manager",
    " project manager",
    " program manager",
    " senior manager (Sr. Manager)",
    " manager",
    " human resources manager",
    " technical services manager",
    " business manager",
    " admin big data",
    " senior associate java",
    " ansible operations engineer",
    " artifactory administrator",
    " [artificial intelligence, machine learning sr.leader]",
    " [artificial intelligence, machine learning leader]",
    " big data specialist",
    " artificial intelligence / machine learning engineer",
    " artificial intelligence researcher",
    " artificial intelligence architect",
    " big data architect",
    " machine learning architect",
    " principle engineer in big data",
    " principle engineer in data analysis",
    " principle engineer in machine learning",
    " principle engineer in artificial intelligence",
    " big data engineer",
    " build and release engineer",
    " build engineer",
    " chef operations engineer",
    " applied scientist",
    " data scientist",
    " data analysts",
    " data architect",
    " devops architect",
    " devops engineer",
    " elk engineer",
    " gerrit administrator",
    " jenkins engineer",
    " jira administrator",
    " kubernetes operations engineer",
    " machine learning engineer",
    " operations engineer",
    " production support engineer",
    " puppet operations engineer",
    " senior build and release engineer",
    " senior build engineer",
    " senior devops engineer",
    " senior site reliability engineer",
    " site reliability engineer",
    " splunk engineer",
    " .net developer",
    " accessibility specialist",
    " agile project manager",
    " android developer",
    " ansible automation engineer",
    " appdynamics engineer",
    " application security engineer",
    " artifactory engineer",
    "machine learning engineer",
    " ai engineer",
    " aws devops engineer",
    " aws solutions architect",
    " azure devops engineer",
    " bamboo engineer",
    " bitbucket engineer",
    " blockchain developer",
    " business systems analyst",
    " c# developer",
    " chef inspec engineer",
    " cloud administrator",
    " cloud architect",
    " cloud automation engineer",
    " cloud engineer",
    " cloud network engineer",
    " cloud security engineer",
    " cnc programmer",
    " coder",
    " computer graphics animator",
    " computer hardware engineer",
    " computer network architect",
    " computer programmer",
    " computer research scientist",
    " computer systems analyst",
    " confluence engineer",
    " consul engineer",
    " coverage.py engineer",
    " data analyst",
    " data engineer",
    " data modeler",
    " database administrator",
    " datadog engineer",
    " developer",
    " devops manager",
    " devsecops architect",
    " devsecops engineer",
    " director of engineering",
    " docker engineer",
    " embedded software engineer",
    " entry level developer",
    " entry level network engineer",
    " entry level programmer",
    " entry level software developer",
    " entry level software engineer",
    " entry level web developer",
    " envoy engineer",
    " falco engineer",
    " fluentd engineer",
    " fortify engineer",
    " frameworks specialist",
    " frontend developer",
    " front end web developer",
    " frontend designer",
    " full stack designer",
    " full stack engineer",
    " full stack developer",
    " full stack java engineer ",
    " full stack java programmer ",
    " full stack python programmer ",
    " full stack python engineer ",
    " full stack java developer ",
    " full stack python developer",
    " game developer",
    " gcp devops engineer",
    " gerrit engineer",
    " git engineer",
    " github engineer",
    " gitlab engineer",
    " gradle engineer",
    " grafana engineer",
    " groovy engineer",
    " information architect",
    " information security analyst",
    " interaction designer",
    " ios developer",
    " istio engineer",
    " jacoco engineer",
    " java developer",
    " javascript developer",
    " jira engineer",
    " jr developer",
    " junior developer",
    " junior front end developer",
    " junior ios developer",
    " junior software developer",
    " junior software engineer",
    " junior web developer",
    " junit engineer",
    " kubernetes administrator",
    " kubernetes engineer",
    " maven engineer",
    " micro services / api lead designer",
    " mobile app developer",
    " mobile application developer",
    " mobile developer",
    " mulesoft developer",
    " nagios engineer",
    " network and systems administrator",
    " network engineer",
    " new grad software engineer",
    " new relic engineer",
    " nexus engineer",
    " nomad engineer",
    " notary engineer",
    " octopus deploy engineer",
    " openshift engineer",
    " openstack engineer",
    " oracle developer",
    " oracle sql developer",
    " packer engineer",
    " php developer",
    " powershell engineer",
    " product manager",
    " programmer",
    " programmer analyst",
    " prometheus engineer",
    " puppet engineer",
    " pytest engineer",
    " python developer",
    " qa specialist",
    " qa engineer",
    " react developer",
    " robotics engineer",
    " ruby on rails developer",
    " salesforce developer",
    " search engine optimization",
    " security specialist",
    " selenium engineer",
    " senior ansible development engineer",
    " senior cloud architect (Sr. cloud architect)",
    " senior devops architect ( Sr. devops architect)",
    " senior devsecops architect",
    " senior devsecops engineer",
    " senior sre architect",
    " senior sre engineer",
    " sharepoint developer",
    " software developer",
    " software developers",
    " software engineer I",
    " software engineer II",
    " software engineer III",
    " software engineer IV",
    " software engineer 1",
    " software engineer 2",
    " software engineer 3",
    " software engineer 4",
    " software engineer",
    " sonarqube engineer",
    " splunk enterprise security engineer",
    " sql developer",
    " sre architect",
    " sre engineer",
    " systems administrator",
    " systems engineer",
    " teamcity engineer",
    " tech sales engineer",
    " technical account manager",
    " technical lead",
    " terraform engineer",
    " tfs engineer",
    " twistkock engineer",
    " udeploy engineer",
    " ui designer",
    " ui developer",
    " unity developer",
    " ux designer",
    " vault engineer",
    " web designer (ui/ux designer)",
    " web developer",
    " wordpress developer",
    " xl deploy engineer",
    " zabbix engineer",
    " associate java",
    "Specialist",
    "Senior Specialist",
    "Senior Advisory Software Engineer (Sr. Advisory Software Engineer)",
    "Senior Specialist (Sr. Specialist)",
    "Scientific Officer",
    "software engineer trainee",
    "Lead Software Development Engineer ",
    "Senior Python Developer",
    "Software Technical Lead Engineer",
    "Senior Software Development Engineer (Sr. Software Development Engineer)",
    "Senior Engineer (Sr. Engineer)",
    "Software Development Engineer",
    "Software Development Engineer I (SDE-I)",
    "Software Development Engineer II (SDE-II)",
    "Software Development Engineer III (SDE-III)",
    "Software Development Engineer 1 (SDE-1)",
    "Software Development Engineer 2 (SDE-2)",
    "Software Development Engineer 3 (SDE-3)",
    "Product Developer Support",
    "Senior Consultant",
    "Consultant",
    "Associate Consultant ",
    "Cyber Security Strategy Consultant",
    "Dynamics AX - Functional Consultant",
    "Field Technical Consultant",
    "Sap Security Consultant",
    "Software Implementation Consultant",
    "Senior Lync Consultant",
    "Technology Consultant",
    "Telecom Analyst",
    "Websphere Consultant",
    "Management Consultant",
    "Lead Software Engineer ",
    " Associate Software Engineer",
    "Senior Java/Backend Developer",
    "Backend Developer",
    "Senior Backend Developer",
    "Software Designer",
    "Senior Software Designer (Sr. Software Designer",
    " Senior Associate",
    "Database Engineer",
    "Java Programmer",
    "Senior member Technical",
    "Scrum Master",
    "Associate System Engineer",
    "System Engineer",
    "Technical Architect",
    "Architect",
    "Project Lead",
    "Development Engineer 1",
    "Development Engineer 2",
    "Engineering Manager 2",
    "Engineering Manager 1",
    "Engineering Manager",
    "Senior Java Software Engineer (Sr. Java Software Engineer)",
    "Software Development Manager",
    "Staff Software Engineer",
    "Software Engineer (Android)",
    "Software Engineer-Android",
    "Deep Learning Engineer",
    "Machine Learning Specialist",
    "Support Engineer",
    "Senior Software Architect (Sr. Software Architect)",
    "Software Analyst II",
    "Software Analyst I",
    "Software Analyst III",
    "Software Analyst",
    "Software Technologist I",
    "Python Developer",
    "Data Engineer",
    "Senior Business Analyst (Sr. Business Analyst)",
    "Java/Scala Technical Lead",
    "Software Developer Consultant",
    "Principal Software Engineer I",
    "Software Engineering Lead - ML",
    "Data Quality Engineer",
    "Analyst, Performance Analytics",
    "Business Development Associate",
    "Developer Associate",
    "Specialist Software Engineer",
    "software Engineer-Data Services",
    "Principal Sotware Engineer",
    "Senior Quality Assurance Engineer",
    "Quality Assurance Associate",
    "Quality Assurance Engineer",
    "Senior Associate Data Analyst",
    "Associate Data Analyst",
    "Manager Data Analyst",
    "Data Analyst",
    "Analyst",
    "Technical Analyst",
    "Senior Associate Technical Analyst",
    "Associate Technical Analyst",
    "Manager Technical Analyst",
    "Senior Associate Analyst",
    "Associate Analyst",
    "Manager Analyst",
    "Manager Analytics",
    "Senior Associate Analytics",
    "Associate Analytics",
    "ReactJS Developer",
    "Senior React Developer",
    "Senior ReactJS Developer"
]